import { jsxs as T, Fragment as w, jsx as p } from "react/jsx-runtime";
import f from "react";
import { clsx as O } from "../../utils/clsx.js";
import { useOutlet as k } from "../../utils/hooks.js";
import { mergeRefs as y } from "../../utils/mergeRefs.js";
import '../../assets/Title.css';const C = "_wrapper_1l1sn_1", R = "_appearance_1l1sn_1", $ = "_animated_1l1sn_26", M = "_root_1l1sn_71", N = "_shortcut_1l1sn_84", m = {
  wrapper: C,
  appearance: R,
  animated: $,
  "fixed-on-top": "_fixed-on-top_1l1sn_29",
  "fixed-on-top-left": "_fixed-on-top-left_1l1sn_35",
  "fixed-on-bottom": "_fixed-on-bottom_1l1sn_41",
  "fixed-on-bottom-left": "_fixed-on-bottom-left_1l1sn_47",
  "fixed-on-bottom-right": "_fixed-on-bottom-right_1l1sn_53",
  "fixed-on-left": "_fixed-on-left_1l1sn_59",
  "fixed-on-right": "_fixed-on-right_1l1sn_65",
  root: M,
  shortcut: N
}, i = 10, S = "title-outlet";
function F(l, a, [e, n]) {
  const r = l ? n : n - 20, s = l ? e : e + 16;
  return {
    // Prefer top and left for element to snap to the pixel grid
    // as when using transform it will become blurry in most of the cases as top and left values are floats
    top: `${r}px`,
    left: `${s}px`,
    // transform: `translate(${left}px, ${top}px)`,
    maxWidth: `calc(100vw - ${s}px - 10px)`,
    animationDelay: `${a}ms`
  };
}
function I(l, a) {
  const {
    x: e,
    y: n,
    width: r,
    height: s
  } = l.getBoundingClientRect();
  let t = 0, c = 0;
  switch (a) {
    case "top": {
      t = e + r / 2, c = n - i;
      break;
    }
    case "top-left": {
      t = e, c = n - i;
      break;
    }
    case "bottom": {
      t = e + r / 2, c = n + s + i;
      break;
    }
    case "bottom-left": {
      t = e, c = n + s + i;
      break;
    }
    case "bottom-right": {
      t = e + r, c = n + s + i;
      break;
    }
    case "left": {
      t = e - i, c = n + s / 2;
      break;
    }
    case "right": {
      t = e + r + i, c = n + s / 2;
      break;
    }
  }
  return [t, c];
}
function B(l) {
  const {
    title: a,
    children: e,
    animated: n = !0,
    fixedOn: r = "bottom",
    delay: s = 0
  } = l, t = f.useRef(r);
  t.current = r;
  const c = k(S), o = f.useRef(null), [g, x] = f.useState(!1), [E, _] = f.useState([0, 0]);
  f.useEffect(() => {
    if (!o.current)
      return;
    const d = (u) => {
      t.current && o.current ? _(I(o.current, t.current)) : _([u.clientX, u.clientY]), x(!0);
    }, v = () => {
      x(!1);
    }, b = (u) => {
      t.current || _([u.clientX, u.clientY]);
    };
    return o.current.addEventListener("mouseenter", d), o.current.addEventListener("mouseleave", v), o.current.addEventListener("mousemove", b), () => {
      o.current && (o.current.removeEventListener("mouseenter", d), o.current.removeEventListener("mouseleave", v), o.current.removeEventListener("mousemove", b));
    };
  }, []);
  let h = null;
  if (g && a) {
    const d = O(m.wrapper, m[`fixed-on-${r}`], {
      [m.animated]: n
    });
    h = /* @__PURE__ */ p(c, { children: /* @__PURE__ */ p("div", { className: d, style: F(!!r, s, E), children: /* @__PURE__ */ p("div", { className: m.root, children: a }) }) });
  }
  const L = typeof e == "function" ? e(o) : f.cloneElement(e, {
    ref: y(o, e.props.ref)
  });
  return /* @__PURE__ */ T(w, { children: [
    L,
    h
  ] });
}
export {
  S as TITLE_OUTLET_ID,
  B as Title
};
